import apiClient from '../client';
import type { FeeStructure, CreateFeeStructurePayload, UpdateFeeStructurePayload } from '@/types';

export const feeStructuresApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: FeeStructure[] }>('/fee-structures', { params }).then((r) => r.data.data),

  getBySession: (sessionId: number) =>
    apiClient.get<{ data: FeeStructure[] }>(`/fee-structures/by-session/${sessionId}`).then((r) => r.data.data),

  getById: (id: number) =>
    apiClient.get<{ data: FeeStructure }>(`/fee-structures/${id}`).then((r) => r.data.data),

  create: (payload: CreateFeeStructurePayload) =>
    apiClient.post<{ data: FeeStructure }>('/fee-structures', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateFeeStructurePayload) =>
    apiClient.put<{ data: FeeStructure }>(`/fee-structures/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/fee-structures/${id}`),
};

